import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaqRoutingModule } from './faq-routing.module';
import { FaqsPageComponent } from './page/faqs-page/faqs-page.component';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    FaqsPageComponent
  ],
  imports: [
    CommonModule,
    FaqRoutingModule,
    CoreModule,
    SharedModule
  ]
})
export class FaqModule { }
